import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppSettings } from '../appSettings';
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';

import * as moment from 'moment';
import { Subject } from 'rxjs';

import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { AppFormat } from '../appFormat';
import { IOption } from '../interfaces/option';
import { ActivatedRoute } from '@angular/router';
import { OperadorService } from '../services/operador.service';
import { ProductService } from '../services/product.service';
import { IProduct } from '../interfaces/product';
import { NavigationService } from '../services/navigation-service.service';
import { IPromotion } from '../interfaces/promotion';
import { PromotionService } from '../services/promotion.service';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.component.html',
  styleUrls: ['./promotion.component.scss'],
  host: { class: 'wrapper-promotion' },
  encapsulation: ViewEncapsulation.None,
})
export class PromotionComponent implements OnInit {
  public promotionFrm: FormGroup;
  public descricao: FormControl;
  public aplica: FormControl;
  public tipo_desconto: FormControl;
  public valor: FormControl;
  public status: FormControl;

  public seleciona: FormControl;
  public quantidade: FormControl;
  public marca: FormControl;
  public total: FormControl;

  public tipo_requisito: FormControl;
  public desconto_modo: FormControl;
  public tipo_limite: FormControl;
  public tipo_condicao: FormControl;

  public dt_inicio: FormControl;
  public dt_expiracao: FormControl;
  public hora_inicial: FormControl;
  public hora_expiracao: FormControl;
  public flag_final: FormControl;
  public investimento_maximo: FormControl;
  public quantidade_maxima: FormControl;
  public aplicar_filiais: FormControl;

  public valores: FormArray;

  public search: FormControl;

  public produtos: IProduct[];
  public produtosGratis: IProduct[];

  public productChange: boolean = false;
  public productGratisChange: boolean = false;

  public tipo_condicao_list: IOption[] = [];
  public tipo_limite_list: IOption[] = [];
  public desconto_modo_list: IOption[] = [];
  public aplica_list: IOption[] = [];
  public tipo_desconto_list: IOption[] = [];
  public seleciona_list: IOption[] = [];
  public tipo_requisito_list: IOption[] = [];

  public showModal: boolean = false;
  public openModal: boolean = false;
  public changeDetail: boolean = false;
  public modalType: string = '';

  private operador;

  public searchTerm$ = new Subject<string>();
  public page: number = 1;

  private query;
  public strSearch = '';

  public products: IProduct[];
  public produtosSelected: IProduct[];
  public produtosGratisSelected: IProduct[];
  public loadingProducts: boolean = false;

  public loading: boolean = false;

  public loadingCheck: boolean = false;
  public errorCode: boolean = false;
  public timeCheckOut = null;

  public promotion: IPromotion = null;

  public startDate = new Date();

  public isMatriz: boolean = false;

  public uploader: FileUploader;
  public imageSelo: string;
  public num_uploads: number;

  constructor(
    private _operadorService: OperadorService,
    private _apiService: ApiService,
    private _productService: ProductService,
    private _promotionService: PromotionService,
    private _route: ActivatedRoute,
    private navigation: NavigationService
  ) {
    this.operador = _operadorService.getOperador();

    if (this.operador['estabelecimento']) {
      this.isMatriz = this.operador['estabelecimento']['matriz'] == 'S';
    }

    this.query = { page: this.page };
    this.produtos = [];
    this.produtosGratis = [];

    this._productService
      .searchProduct(this.searchTerm$, this.query)
      .subscribe((res) => {
        this.products = this.checkListProducts(
          this.page > 1 ? this.products.concat(res.data) : res.data
        );

        this.loadingProducts = false;

        console.log(this.query);
        this.page = this.page + 1;
      });

    /**
     *
     * envio do selo da promocao para entrega
     *
     */

    this.uploader = new FileUploader({
      url: _apiService.API_PATH,
      allowedFileType: ['image'],
      allowedMimeType: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
      maxFileSize: 1048576 * 2,
      filters: [
        {
          name: 'imageFilter',
          fn: function (item /*{File|FileLikeObject}*/, options) {
            var type =
              '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|gif|webp|'.indexOf(type) !== -1;
          },
        },
      ],
    });

    this.uploader.onAfterAddingFile = (f) => {
      f.withCredentials = false;

      if (this.uploader.queue.length > 1) {
        this.uploader.removeFromQueue(this.uploader.queue[0]);
      }

      this.imageSelo = '';
      this.onChangeDetail();
    };

    this.uploader.onBeforeUploadItem = (fileItem: any) => {
      fileItem.options.additionalParameter = {
        idpromocao: this.promotion.idpromocao,
      };
    };

    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: number,
      headers: any
    ) => {
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          this.promotion.img_selo = responsePath['img_selo'];

          this.imageSelo =
            AppSettings.URL_IMG_ESTABELECIMENTO +
            this.promotion.idestabelecimento +
            '/promocao/' +
            this.promotion.img_selo;
        }
      }
    };

    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue();
      this.num_uploads -= 1;

      console.log('uploader', this.num_uploads);

      if (this.num_uploads <= 0) {
        this.saveComplete();
      }
    };

    this.uploader.onErrorItem = (
      item: FileItem,
      response: any,
      status: any,
      headers: any
    ) => {
      //console.log(item)

      item.remove();

      Swal.fire(
        'Ops!',
        'Ocorreu um erro ao processar a imagem, verifique se a imagem está correta! Se é um arquivo válido de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho',
        'error'
      );
    };

    this.uploader.onWhenAddingFileFailed = function (
      item: FileLikeObject,
      filter: any,
      options: any
    ) {
      //console.log(item);
      //console.log(filter);
      //console.log(options);

      Swal.fire(
        'Ops!',
        'O arquivo selecionado não é válido, verifique se é um arquivo de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho!',
        'error'
      );
    };
  }

  ngOnInit(): void {
    this.createFormControls();
    this.createForm();

    this.changeDetail = false;
    this.productChange = false;

    this.desconto_modo_list.push({ text: 'Desconto comum', value: 'C' });
    this.desconto_modo_list.push({ text: 'Desconto proporcional', value: 'P' });

    this.aplica_list.push({ text: 'Produto grátis (brinde)', value: 'G' });
    this.aplica_list.push({ text: 'Desconto no frete do pedido', value: 'F' });
    // this.aplica_list.push({ text: 'A cada X unidades', value: 'C' });

    this.tipo_desconto_list.push({ text: 'Percentual', value: 'P' });
    this.tipo_desconto_list.push({ text: 'Valor Fixo', value: 'F' });

    this.seleciona_list.push({ text: 'Valor do Pedido', value: 'C' });
    this.seleciona_list.push({ text: 'Pela Marca', value: 'M' });
    this.seleciona_list.push({ text: 'Por Produto(s)', value: 'L' });
    this.seleciona_list.push({ text: 'Pelo gênero do usuário', value: 'G' });

    this.tipo_limite_list.push({ text: 'Investimento máximo de', value: 'V' });
    this.tipo_limite_list.push({ text: 'Quantia máxima de', value: 'Q' });

    this.tipo_condicao_list.push({ text: 'Drive-thru', value: 'R' });
    this.tipo_condicao_list.push({ text: 'Delivery', value: 'E' });

    this.imageSelo = '';

    this.produtos = [];

    this.loading = true;
    this._route.params.subscribe((data) => {
      //console.log(data['codbarra'])
      if (data['id'] !== undefined) {
        this.getPromotionFromId(data['id']);
      } else {
        this.loading = false;
      }
    });
  }

  createFormControls() {
    this.descricao = new FormControl('', [Validators.required]);

    this.aplica = new FormControl(null);
    this.tipo_desconto = new FormControl('P');
    this.valor = new FormControl(null);

    this.desconto_modo = new FormControl('C');

    this.tipo_requisito = new FormControl(null);
    this.tipo_condicao = new FormControl(null);

    this.seleciona = new FormControl(null);
    this.quantidade = new FormControl(null);
    this.marca = new FormControl(null);
    this.total = new FormControl(null);

    this.dt_inicio = new FormControl(null);
    this.dt_expiracao = new FormControl(null);
    this.investimento_maximo = new FormControl(null);
    this.quantidade_maxima = new FormControl(null);
    this.aplicar_filiais = new FormControl(false);
    this.status = new FormControl(true);

    this.tipo_limite = new FormControl(null);
    this.flag_final = new FormControl('L');
    this.hora_inicial = new FormControl(null);
    this.hora_expiracao = new FormControl(null);

    this.valores = new FormArray([]);
  }

  createForm() {
    this.promotionFrm = new FormGroup({
      descricao: this.descricao,
      aplica: this.aplica,
      status: this.status,
      desconto_modo: this.desconto_modo,
      tipo_desconto: this.tipo_desconto,
      valor: this.valor,
      seleciona: this.seleciona,
      quantidade: this.quantidade,
      marca: this.marca,
      total: this.total,
      tipo_requisito: this.tipo_requisito,
      valores: this.valores,
      dt_inicio: this.dt_inicio,
      dt_expiracao: this.dt_expiracao,
      investimento_maximo: this.investimento_maximo,
      quantidade_maxima: this.quantidade_maxima,
      aplicar_filiais: this.aplicar_filiais,
      hora_inicial: this.hora_inicial,
      hora_expiracao: this.hora_expiracao,
      flag_final: this.flag_final,
      tipo_limite: this.tipo_limite,
      tipo_condicao: this.tipo_condicao,
    });
  }

  onAddValue(obj) {
    this.valores.push(
      new FormGroup({
        tipo_requisito: new FormControl(
          obj != undefined && obj.tipo_requisito ? obj.tipo_requisito : 'V'
        ),
        tipo_desconto: new FormControl(
          obj != undefined && obj.tipo_desconto ? obj.tipo_desconto : 'P'
        ),
        valor: new FormControl(
          obj != undefined && obj.valor ? obj.valor : null
        ),
        desconto: new FormControl(
          obj != undefined && obj.desconto ? obj.desconto : null
        ),
      })
    );
  }

  onRemoveValue(i) {
    Swal.fire({
      title: 'Você deseja remover o valor do desconto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        let fGroup = <FormGroup>this.valores.controls[i];
        let valor = <FormControl>fGroup.controls.valor;

        valor.setValue(-1);

        this.onChangeDetail();
      }
    });
  }

  configRequisito(i) {
    if (i == 'Q') {
      return { precision: 0, allowNegative: false };
    } else {
      return { precision: 2, allowNegative: false };
    }
  }

  onBack() {
    this.navigation.back();
  }

  getPromotionFromId(id) {
    this._promotionService.show(id).subscribe((res) => {
      if (res.idpromocao) {
        this.productChange = false;

        this.promotion = res;

        this.descricao.setValue(res.descricao);
        this.aplica.setValue(res.aplica);
        this.tipo_desconto.setValue(res.tipo_desconto);
        this.valor.setValue(res.valor);

        this.tipo_requisito.setValue(res.tipo_requisito);
        this.desconto_modo.setValue(res.desconto_modo);
        this.tipo_condicao.setValue(res.tipo_condicao);

        this.seleciona.setValue(res.seleciona);
        this.quantidade.setValue(res.quantidade);
        this.marca.setValue(res.marca);
        this.total.setValue(res.total);

        this.tipo_limite.setValue(res.tipo_limite);
        this.flag_final.setValue(res.flag_final);

        this.status.setValue(res.status == 'A' ? true : false);

        this.investimento_maximo.setValue(res.investimento_maximo);
        this.quantidade_maxima.setValue(res.quantidade_maxima);
        this.aplicar_filiais.setValue(
          res.aplicar_filiais == 'S' ? true : false
        );

        this.produtos = res.produtos;

        this.produtosGratis = res.produtos_gratis;

        if (this.promotion.img_selo != null && this.promotion.img_selo != '') {
          this.imageSelo =
            AppSettings.URL_IMG_ESTABELECIMENTO +
            this.promotion.idestabelecimento +
            '/promocao/' +
            this.promotion.img_selo;
        }

        if (res.dt_inicio && res.dt_inicio != null) {
          let dtinicial = res.dt_inicio.split(' ');
          this.dt_inicio.setValue(AppFormat.dateYMDUTCMoment(dtinicial[0]));
          if (dtinicial.length > 1) {
            let horainicial = dtinicial[1].split(':');
            this.hora_inicial.setValue(horainicial[0] + ':' + horainicial[1]);
          }
        }

        if (
          res.flag_final == 'D' &&
          res.dt_expiracao &&
          res.dt_expiracao != null
        ) {
          let dtexpiracao = res.dt_expiracao.split(' ');
          this.dt_expiracao.setValue(
            AppFormat.dateYMDUTCMoment(dtexpiracao[0])
          );
          if (dtexpiracao.length > 1) {
            let horaexpiracao = dtexpiracao[1].split(':');
            this.hora_expiracao.setValue(
              horaexpiracao[0] + ':' + horaexpiracao[1]
            );
          }
        }

        if (res['valores'] && res['valores'].length > 0) {
          this.valores.clear();
          for (let i in res['valores']) {
            this.onAddValue({
              tipo_requisito: res['valores'][i]['tipo_requisito'],
              tipo_desconto: res['valores'][i]['tipo_desconto'],
              valor: res['valores'][i]['valor'],
              desconto: res['valores'][i]['desconto'],
            });
          }
        }

        this.onChangeTypeSelection();
        this.changeDetail = false;
      }
      this.loading = false;
    });
  }

  onChangeTypePromotion() {
    if (this.aplica.value == 'C') {
      this.seleciona.setValue('L');
      this.desconto_modo.setValue('C');
      this.tipo_requisito.setValue('Q');
      this.tipo_desconto.setValue('F');
      this.tipo_limite.setValue(null);
      this.flag_final.setValue('D');
    }
    this.onChangeDetail();
  }

  onChangeTypeSelection() {
    this.tipo_requisito_list = [];
    if (this.seleciona.value == 'G') {
      this.desconto_modo.setValue('C');
      this.tipo_requisito_list.push({ text: 'Masculino', value: 'M' });
      this.tipo_requisito_list.push({ text: 'Feminino', value: 'F' });
      this.tipo_requisito_list.push({ text: 'Outro', value: 'O' });
    } else {
      this.tipo_requisito_list.push({ text: 'Valor mínimo de', value: 'V' });
      this.tipo_requisito_list.push({ text: 'Quantia mínima de', value: 'Q' });
    }
    this.onChangeDetail();
  }

  onChangeDetail() {
    this.changeDetail = true;
  }

  resetPageSearch() {
    this.page = 1;
    this.query = { page: this.page };
    this.loadingProducts = true;
  }

  public selectProduct(product: IProduct) {
    product['selected'] = !product['selected'];
    if (product['selected']) {
      if (this.modalType == 'P') {
        this.produtosSelected.push(product);
      } else if (this.modalType == 'G') {
        this.produtosGratisSelected.push(product);
      }
    } else {
      let j = null;
      if (this.modalType == 'P') {
        for (let i in this.produtosSelected) {
          if (
            this.produtosSelected[i].idproduto_geral == product.idproduto_geral
          ) {
            j = i;
            break;
          }
        }
      } else {
        for (let i in this.produtosGratisSelected) {
          if (
            this.produtosGratisSelected[i].idproduto_geral ==
            product.idproduto_geral
          ) {
            j = i;
            break;
          }
        }
      }
      if (j != null) {
        if (this.modalType == 'P') {
          this.produtosSelected.splice(j, 1);
        } else if (this.modalType == 'G') {
          this.produtosGratisSelected.splice(j, 1);
        }
      } else {
        for (let i in this.produtos) {
          if (this.produtos[i].idproduto_geral == product.idproduto_geral) {
            j = i;
            break;
          }
        }
        if (j != null) {
          this.produtos.splice(j, 1);
        }
      }
    }
    if (this.modalType == 'P') {
      this.productChange = true;
    } else if (this.modalType == 'G') {
      this.productGratisChange = true;
    }
    this.onChangeDetail();
  }

  private checkListProducts(list) {
    for (let i in list) {
      list[i]['selected'] = false;
      for (let j in this.produtos) {
        if (this.produtos[j]['idproduto_geral'] == list[i]['idproduto_geral']) {
          list[i]['selected'] = true;
        }
      }

      for (let j in this.produtosSelected) {
        if (
          this.produtosSelected[j]['idproduto_geral'] ==
          list[i]['idproduto_geral']
        ) {
          list[i]['selected'] = true;
        }
      }
    }

    return list;
  }

  private findProducts() {
    this.query['page'] = this.page;
    this.query['search'] = this.strSearch;

    this.loadingProducts = true;

    this._productService.search(this.query).subscribe(
      (res) => {
        if (res['success']) {
          this.products = this.checkListProducts(
            this.page > 1 ? this.products.concat(res.data) : res.data
          );

          this.page = this.page + 1;

          this.loadingProducts = false;
        } else {
          //error
        }
      },
      (error) => {}
    );
  }

  openModalProducts(tipo) {
    this.products = [];
    this.produtosSelected = [];
    this.produtosGratisSelected = [];
    this.showModal = true;
    this.modalType = tipo;
    this.strSearch = '';
    setTimeout(() => {
      this.openModal = true;
    }, 200);
  }

  putProducts() {
    if (this.modalType == 'P') {
      for (let i in this.produtosSelected) {
        this.produtos.push(this.produtosSelected[i]);
      }
      this.produtosSelected = [];
    } else if (this.modalType == 'G') {
      for (let i in this.produtosGratisSelected) {
        this.produtosGratis.push(this.produtosGratisSelected[i]);
      }
      this.produtosGratisSelected = [];
    }
    this.closeModalProducts();
    this.onChangeDetail();
  }

  closeModalProducts() {
    this.openModal = false;
    setTimeout(() => {
      this.showModal = false;
    }, 200);
  }

  onScroll() {
    if (!this.loading) {
      this.findProducts();
    }
  }

  promotionValid() {
    let has = true;

    let msg = [];

    if (
      (this.descricao.invalid &&
        (this.descricao.dirty || this.descricao.touched)) ||
      this.descricao.value == '' ||
      this.descricao.value == undefined ||
      this.descricao.value == null
    ) {
      msg.push('Você precisa preencher a descrição da promoção!');
      has = false;
    }

    if (msg.length > 0) {
      Swal.fire('Ops!', msg.join('<br>'), 'error');
    }

    return has;
  }

  onCancelPromotion() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.getPromotionFromId(this.promotion.idpromocao);
      }
    });
  }

  onRemoveImage() {
    Swal.fire({
      title: 'Você deseja excluir o selo da condição?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        if (this.imageSelo == '') {
          this.uploader.removeFromQueue(this.uploader.queue[0]);
          this.uploader.clearQueue();
        } else {
          Swal.fire({
            title: 'Excluindo...',
            icon: 'info',
            showCancelButton: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            heightAuto: false,
          });

          this._promotionService
            .removeSelo(this.promotion.idpromocao, this.promotion.img_selo)
            .subscribe((res) => {
              this.imageSelo = '';

              Swal.fire({
                title: 'Excluido!',
                icon: 'success',
                text: 'O selo foi excluido',
                showCancelButton: false,
                allowOutsideClick: true,
                showConfirmButton: true,
                heightAuto: false,
              });

              this.onChangeDetail();
            });
        }
      }
    });
  }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar salvar.', 'error');
  }

  saveComplete() {
    Swal.fire('Salvo!', 'A promoção foi salva', 'success');
  }

  saving() {
    Swal.fire({
      title: 'Salvando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  onSubmit() {
    if (this.promotionValid()) {
      let dtinicial,
        dtexpiracao = '';
      if (
        this.dt_inicio.value != null &&
        typeof this.dt_inicio.value === 'object'
      ) {
        dtinicial = this.dt_inicio.value.format('YYYY-MM-DD');
      } else {
        dtinicial = this.dt_inicio.value;
      }
      if (this.hora_inicial.value != '' && this.hora_inicial.value != null) {
        dtinicial += ' ' + this.hora_inicial.value + ':00';
      } else {
        dtinicial += ' 00:00:00';
      }

      if (
        this.dt_expiracao.value != null &&
        typeof this.dt_expiracao.value === 'object'
      ) {
        dtexpiracao = this.dt_expiracao.value.format('YYYY-MM-DD');
      } else {
        dtexpiracao = this.dt_expiracao.value;
      }
      if (
        this.hora_expiracao.value != '' &&
        this.hora_expiracao.value != null
      ) {
        dtexpiracao += ' ' + this.hora_expiracao.value + ':00';
      } else {
        dtexpiracao += ' 00:00:00';
      }

      let data = {
        descricao: this.descricao.value,
        aplica: this.aplica.value,
        tipo_desconto: this.tipo_desconto.value,
        valor: this.valor.value,
        seleciona: this.seleciona.value,
        quantidade: this.quantidade.value,
        tipo_condicao: this.tipo_condicao.value,
        marca: this.marca.value,
        total: this.total.value,
        tipo_requisito: this.tipo_requisito.value,
        desconto_modo: this.desconto_modo.value,
        flag_final: this.flag_final.value,
        tipo_limite: this.tipo_limite.value,
        dt_inicio: dtinicial,
        dt_expiracao: dtexpiracao,
        investimento_maximo: this.investimento_maximo.value,
        quantidade_maxima: this.quantidade_maxima.value,
        status: this.status.value ? 'A' : 'I',
        aplicar_filiais: this.aplicar_filiais.value ? 'S' : 'N',
      };

      data['produtos'] = [];

      for (let i in this.produtos) {
        data['produtos'].push(this.produtos[i].idproduto_geral);
      }

      if (this.productChange) {
        data['alteracao_produtos'] = true;
      }

      data['produtos_gratis'] = [];

      for (let i in this.produtosGratis) {
        data['produtos_gratis'].push(this.produtosGratis[i].idproduto_geral);
      }

      if (this.productGratisChange) {
        data['alteracao_produtos_gratis'] = true;
      }

      let valores = [];

      for (let i in this.valores.controls) {
        let fGroup = <FormGroup>this.valores.controls[i];

        let desconto = <FormControl>fGroup.controls.desconto;
        let valor = <FormControl>fGroup.controls.valor;

        if (
          desconto.value != null &&
          desconto.value != '' &&
          valor.value != null &&
          valor.value != ''
        ) {
          let d = parseFloat(desconto.value);
          let v = parseFloat(valor.value);
          if (d > 0 && v > 0) {
            let tipo_requisito = <FormControl>fGroup.controls.tipo_requisito;
            let tipo_desconto = <FormControl>fGroup.controls.tipo_desconto;

            valores.push({
              tipo_requisito: tipo_requisito.value,
              valor: v,
              tipo_desconto: tipo_desconto.value,
              desconto: d,
            });
          }
        }
      }

      valores.sort((a, b) => parseFloat(a.valor) - parseFloat(b.valor));

      let lst_valores = [];
      for (let i in valores) {
        let d = valores[i];
        lst_valores.push([
          d.tipo_requisito,
          d.valor,
          d.tipo_desconto,
          d.desconto,
        ]);
      }

      data['valores'] = lst_valores;

      this.saving();

      if (this.promotion != null && this.promotion.idpromocao > 0) {
        this.patchPromotion(this.promotion.idpromocao, data);
      } else {
        this.storePromotion(data);
      }
    }

    return null;
  }

  storePromotion(data) {
    this._promotionService.store(data).subscribe((res) => {
      this.resPromotion(res);
    });
  }

  patchPromotion(id, data) {
    this._promotionService.patch(id, data).subscribe((res) => {
      this.resPromotion(res);
    });
  }

  resPromotion(res) {
    if (res['success']) {
      this.num_uploads = 0;

      this.promotion = res['promotion'];
      if (this.uploader.queue.length > 0) {
        if (this.uploader.queue.length > 0) {
          this.num_uploads += 1;
        }

        this.sendImages();
      } else {
        this.saveComplete();
      }
    } else {
      this.saveError();
    }
  }

  sendImages(): void {
    this.uploader.setOptions({
      url:
        this._apiService.API_PATH +
        'promotion/' +
        this.promotion.idpromocao +
        '/selo',
      authTokenHeader: 'Authorization',
      authToken: 'Bearer ' + this._apiService.getAccessToken(),
    });

    this.uploader.uploadAll();
  }
}
